export default __webpack_public_path__ + "static/media/Coyotes.746bdb43.png";